import TableClientAssigment from './TableClientAssigment';
export default TableClientAssigment;